export default "__VITE_ASSET__CEtq0Mrk__"